export default __webpack_public_path__ + "static/media/sad-dark.13673835.svg";